var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-input',{attrs:{"schema":_vm.schema,"value":_vm.value,"data":_vm.data},on:{"input":_vm.simpleEmit},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('t-anagraphic-cerved',{attrs:{"value":_vm.data,"term":(`${_vm.data.name} ${_vm.value}`.trim())},on:{"input":(v) => _vm.$emit('change', v)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }